export default function htmlParser(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    let chairpersons = [];
    let others = [];
    let moreInfo = "";
    let jury = [];

    const moreInfoElement = doc.querySelector("i");
    if(moreInfoElement?.innerText){
        let text = moreInfoElement.innerText;

        // działa, ale bugi mogą się pojawić 
        // if(text.startsWith("Sesja")){
        //     moreInfo = text;
        // }

        if (moreInfoElement.parentElement.tagName == "BODY") {
            moreInfo = text;
        }
        
        
    }

    const chairpersonElements = doc.querySelectorAll('p:has(u)');

    chairpersonElements.forEach(p => {
        const textContent = p.textContent;
        const start = textContent.indexOf('Przewodniczący');
        if (start !== -1) {
            const info = textContent.substring(start + 'Przewodniczący'.length).trim().split(/\s+/); // Split by one or more spaces

            const titles = ['prof.', 'dr', 'hab.', 'n.', 'med.'];

            let nameParts = info.filter(part => !titles.includes(part));

            let lastPart = nameParts[nameParts.length - 1];
            let city = '';
            if (lastPart.startsWith('(') && lastPart.endsWith(')')) {
                city = lastPart.replace(/[()]/g, '');
                nameParts.pop();
            }

            const nameLength = nameParts.length;

            let name = '';
            if (nameLength >= 2) {
                name = [nameParts[nameLength - 2], nameParts[nameLength - 1]].join(' ');
            } else if (nameLength === 1) {
                name = nameParts[0];
            }

            chairpersons.push({ name, city });
        }
    });

    chairpersonElements.forEach(p => {
        const textContent = p.textContent;
        const start = textContent.indexOf('Jury');
        if (start !== -1) {
            const info = textContent.substring(start + 'Jury'.length).trim().split(/\s+/); // Split by one or more spaces

            const titles = ['prof.', 'dr', 'hab.', 'n.', 'med.'];

            let nameParts = info.filter(part => !titles.includes(part));

            let lastPart = nameParts[nameParts.length - 1];
            let city = '';
            if (lastPart.startsWith('(') && lastPart.endsWith(')')) {
                city = lastPart.replace(/[()]/g, '');
                nameParts.pop();
            }

            const nameLength = nameParts.length;

            let name = '';
            if (nameLength >= 2) {
                name = [nameParts[nameLength - 2], nameParts[nameLength - 1]].join(' ');
            } else if (nameLength === 1) {
                name = nameParts[0];
            }

            jury.push({ name, city });
        }
    });



    let allParagraphs = Array.from(doc.querySelectorAll('p'));
    let newElements = [];

    allParagraphs.forEach(e => e.innerHTML.includes('Panel dyskusyjny') ? newElements.push(e) : console.log(''))

    newElements.forEach(paragraph => {
        let textContent = paragraph.childNodes[2]?.textContent;

        if (textContent && typeof textContent === "string") {
            const words = textContent.split(' ');

            let nameParts = words.slice(0, words.length - 1);
            const lastPart = words[words.length - 1];

            let city = '';
            let name = '';

            if (lastPart.startsWith('(') && lastPart.endsWith(')')) {
                city = lastPart.replace(/[()]/g, '');
                nameParts = words.slice(0, words.length - 1);
            } else {
                nameParts = words;
            }

            // Handle name parsing (using the last two parts)
            const nameLength = nameParts.length;
            name = [nameParts[nameLength - 2], nameParts[nameLength - 1]].join(' ');

            others.push({ name, city });
        }
    });

    return { chairpersons, others, moreInfo, jury };

}
